/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
;// CONCATENATED MODULE: ./src/js/modules/predictive-search.js


class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    _defineProperty(this, "setPopularSearchesLink", () => {
      const {
        popularSearchItems
      } = this.domNodes;
      popularSearchItems.forEach(itm => itm.href = createSearchLink(itm.dataset.psQuery));
    });

    this.selectors = {
      searchQuery: '[data-query]',
      searchMessage: '[data-message]',
      input: '[data-search-input]',
      submit: 'button[type="submit"]',
      loading: '[data-spinner]',
      clear: '[data-clear-search]',
      popularSearchItems: ['[data-ps-item]']
    };
    this.container = document.querySelector('[data-search-popup]');
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.cachedResults = {};
    this.transitionDuration = 300;
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.popularSearches = this.querySelector('[data-popular-searches]');
    this.searchCount = this.querySelector('[data-search-count]');
    this.setupEventListeners();
    this.setPopularSearchesLink();
  }

  setupEventListeners() {
    const {
      clear
    } = this.domNodes;
    const form = this.querySelector('form.m-search-form');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', debounce(event => {
      this.onChange(event);
    }, 1000).bind(this));
    clear.addEventListener('click', this.onClearSearch.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults2(searchTerm);
  }


  getSearchResults2(searchTerm) {
    this.toggleSpinnerLoading(true);
    this.toggleClearSearch(false);
    const accessToken = "7ec189702250588ae729b357b6041f94";
    const query = `
      query {
        products(first: 250, query: "title:*${encodeURIComponent(searchTerm)}*") {
          edges {
            node {
              id
              title
              handle
              productType
              images(first: 1) {
                edges {
                    node {
                        id
                        originalSrc
                    }
                }
              }
              metafields(identifiers: [
                {namespace: "custom", key: "event_search_system"},
                {namespace: "custom", key: "product_card_tag"}
              ]) {
                key
                value
              }
            }
          }
        }
      }
    `;

    fetch(`https://filteroutlet.myshopify.com/api/2023-07/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({ query })
    })
      .then(response => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then(data => {
  
        this.toggleSpinnerLoading(false);
        this.toggleClearSearch(true);
        let trueArray = [];
        let emptyArray = [];

        const parsedData = JSON.parse(data);
        parsedData.data.products.edges.forEach(product => {
            const metafields = product.node.metafields || [];
            const metafield = metafields.find(m => m && m.key === 'event_search_system');
            const eventSearchSystemValue = metafield ? metafield.value : '';
        
            if (eventSearchSystemValue.toLowerCase() === 'true') {
                trueArray.push(product);
            } else if (eventSearchSystemValue === '') {
                emptyArray.push(product);
            }
        });

        if (trueArray.length > 4) {
            trueArray = trueArray.slice(0, 4);
        }

        if (emptyArray.length > 4) {
            emptyArray = emptyArray.slice(0, 4);
        }

        
      })
      .catch(error => {
        this.close();
        throw error;
      });
  }

 




  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onClearSearch(event) {
    let windowWidth = $(window).width();
    event.preventDefault();
    this.input.value = '';
    this.onChange();
    
    // $('.search-all-wrap').removeClass('opacity-100').addClass('invisible');
    // $('.wd-search-box').removeClass('md:translate-y-0').addClass('duration-300');
     $('.wd-search-mobile-box-all').css({ display: 'flex' });
    $('.search-show-container,.no-result-show-content').css({ display: 'none' });
    if (windowWidth < 768) {
        $('.search-content-box').css({ padding: '32px 24px 0' });
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.toggleSpinnerLoading(true);
    this.toggleClearSearch(false);
    const searchByTag = this.dataset.searchByTag === 'true';
    const searchByBody = this.dataset.searchByBody === 'true';
    const unavailableProductsOption = this.dataset.unavailableProductsOption;
    let searchFields = 'title,product_type,vendor,variants.sku,variants.title';
    if (searchByTag) searchFields += ',body';
    if (searchByBody) searchFields += ',tag';

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    let searchURL = `${window.MinimogSettings.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][unavailable_products]=${unavailableProductsOption}&resources[options][fields]=${searchFields}&section_id=predictive-search`;
    fetch(`${searchURL}`).then(response => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    }).then(text => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.cachedResults[queryKey] = resultsMarkup;
      this.renderSearchResults(resultsMarkup);
    }).catch(error => {
      this.close();
      throw error;
    });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    const searchItemsWrapper = this.querySelector('[data-search-items-wrapper]');

    if (searchItemsWrapper.childElementCount > 0) {
      this.renderSearchQueryAndMessage(true);
    } else {
      this.renderSearchQueryAndMessage(false);
    }

    this.toggleSpinnerLoading(false);
    this.toggleClearSearch(true);
    this.open();
  }

  renderSearchQueryAndMessage(results) {
    const {
      input,
      searchQuery,
      searchMessage
    } = this.domNodes;
    const query = input.value;
    const {
      resultsTitle
    } = searchMessage.dataset;
    searchQuery.textContent = query;

    if (results) {
      searchMessage.textContent = resultsTitle;
    } else {
      searchMessage.textContent = searchMessage.dataset.noResults;
    }
  }

  toggleSpinnerLoading(show) {
    const {
      loading,
      submit
    } = this.domNodes;
    loading.style.visibility = show ? 'visible' : 'hidden';
  }

  toggleClearSearch(show) {
    const {
      clear
    } = this.domNodes;
    clear.style.visibility = show ? "visible" : "hidden";
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    // this.predictiveSearchResults.classList.remove('hidden');
    this.popularSearches.classList.add('hidden');
    // this.searchCount.classList.remove('hidden');
  }

  close() {
    let clearSearchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.toggleClearSearch(false);
    }

    this.removeAttribute('open');
    // this.predictiveSearchResults.classList.add('hidden');
    this.popularSearches.classList.remove('hidden');
    // this.searchCount.classList.add('hidden');

    let windowWidth = $(window).width();
    if (windowWidth < 768) {
        $('.search-content-box').css({ padding: '32px 24px 0' });
    }
    
  }

}

customElements.define('predictive-search', PredictiveSearch);
/******/ })()
;